import { useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getAllActions } from './api';
import { QueryKey } from '../QueryKey';
import { goToErrorPage } from 'utils';
import { ActionsResponse } from '@components/Activity/types/ActionsRepsonse';

export default function useAllActions() {
  const { t } = useTranslation();

  const { data, isLoading} = useQuery<ActionsResponse>(
    [QueryKey.ACTION_ALL],
    () => getAllActions(),
    {
      onError: (error: any) => {
        goToErrorPage(error);
        toast.error(t('message.title.error.get.all.actions'));
      },
      retry: false,
    }
  );

  return { actions: data?.actions, headerRow: data?.headerRow, isLoading };
}
